module.exports = __webpack_public_path__ + "img/call-phone.c257c680.png";